import React, { useState, useEffect } from 'react';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';


function convertDateToNumber(dateString: string): number {
  const [year, month] = dateString.split('-');
  return parseInt(year + month, 10);
}

const item: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
};

const number = {
  fontSize: 24,
  fontFamily: 'default',
  color: 'primary.main',
  fontWeight: 'medium',
};

const image = {
  height: 55,
  my: 4,
};

interface NewDataItem {
  x: Date;
  y: number;
  id: number;
}

function ProductHowItWorks() {
  return (
    <Box
      component="section"
      sx={{ display: 'flex', bgcolor: 'secondary.light', overflow: 'hidden' }}
    >
      <Container
        sx={{
          mt: 10,
          mb: 15,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          component="img"
          src="/static/themes/onepirate/productCurvyLines.png"
          alt="curvy lines"
          sx={{
            pointerEvents: 'none',
            position: 'absolute',
            top: -180,
            opacity: 0.7,
          }}
        />
        <Typography variant="h1" marked="center" component="div" sx={{ mb: 10, fontSize: '2.0rem' }}>
          プレゼンテーションにおけるマストスキル総論
        </Typography>
        <Typography variant="h5" sx={{ fontSize: 19, margin: "1px" }}>
          プレゼンテーションを構成する要素はなんでしょうか。綺麗なデザインでしょうか？それともシンプルさ？あるいは緻密なリサーチ？
          勿論どれも正解です。下記にマストスキルを一つ一つ丁寧に紹介していくのですが、その前に我々から皆様への大事な3つのメッセージです。<br /><br />

          さて、その前にいきなり余談ですが、戦略コンサルに入ると、毎日遭遇するのがこんな会話。「で、結局のところポイントは何？3つ教えて？」こんな会話がいつも聞こえてきます。
          なんで3つなんだろうと思っていたわけですが（いやMECEじゃないし、もっとあるだろうと、笑）、コンサルを3年やったときのある日、ファームのパートナー（役員）に言われました。
          「何万人もいる大企業のトップも、きっと本当は言いたいことはたくさんあるけれど、
          社員へのメッセージはいつも3つ。それくらいクリスタライズされたシンプルなメッセージじゃないと人は覚えられないし、組織は動かない」）<br /><br />

          本題です。というわけでここでもメッセージは3つ。細かなスキル獲得の前に覚えてください。プレゼンには下記の考慮が必須です。<br />
          1.プレゼンの背景となる課題（コンサル風に言うとイシュー）は何か（言い換えると、リスナーが解決したいことは何か）<br />
          2.その課題に対する答え（コンサル風に言うとキーメッセージ）は何か（言い換えると、あなたの主張は何か）　<br />
          3.それのメッセージは何故そう言えるのか　<br /><br />

          大きな組織であればあるほど、No1が忘れ去られる傾向が強いです。数百人を束ねる部長職であっても
          上の3つもポイントを外していることが多いです。逆に言うと、この3つの要素をしっかり意識してプレゼンをすれば、結構いいところまでいきます。<br /><br />

          シンプルではありますが、重要です。プレゼンを作り終わった際、この3つのポイントを満たしているのか、改めてプレゼンを見直してみてください。

        </Typography>
      </Container>
    </Box>
  );
}

export default ProductHowItWorks;
